export default "__VITE_ASSET__7410dad2__"